import React, { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import PaceProgressActions from '../../actions/PaceProgressActions';

const PaceProgress = ({
    active,
    total,
    uploaded,
    startWidth = 10,
    width = 0,
    duration = 250,
    delayFactor = 1.2
}) => {
    const [state, setState] = useState({
        active: active,
        total: total,
        uploaded: uploaded,
        width: width
    });

    const getWidth = useCallback((totalValue, uploadedValue) => {
        let percent = totalValue ? (100 * uploadedValue / totalValue) : 0;
        return active && percent < startWidth ? startWidth : percent;
    }, [active, startWidth]);

    const onEndLoading = useCallback(() => {
        setState(prevState => ({
            ...prevState,
            active: false,
            width: 0
        }));
    }, []);

    const getClassMain = useCallback(() => {
        return classNames({
            'pace': true,
            'pace-active': state.active
        });
    }, [state.active]);

    useEffect(() => {
        setState(prevState => ({
            ...prevState,
            width: getWidth(prevState.total, prevState.uploaded)
        }));

        PaceProgressActions.startUpdatePage();
    }, [getWidth]);

    useEffect(() => {
        const isEndLoading = !active && !total && !uploaded;
        let newState = {
            total: total,
            uploaded: uploaded,
            active: true,
            width: 100
        };

        if (!isEndLoading) {
            newState.active = active;
            newState.width = getWidth(total, uploaded);
        }

        setState(prevState => ({
            ...prevState,
            ...newState
        }));

        if (isEndLoading) {
            setTimeout(onEndLoading, duration * delayFactor);
        }
    }, [active, total, uploaded, getWidth, onEndLoading, duration, delayFactor]);

    return (
        <div className={getClassMain()}>
            <div className="pace-progress" style={{width: `${state.width}%`}} />
        </div>
    );
};

PaceProgress.propTypes = {
    startWidth: PropTypes.number,
    width: PropTypes.number,
    duration: PropTypes.number,
    delayFactor: PropTypes.number
};

export default PaceProgress;
